<template>
  <div
    v-if="loading"
    class="flex justify-center my-4"
  >
    <CarvisSpinner class="w-24 h-24" />
  </div>
  <div
    v-else-if="items?.length === 0"
    aria-label="table-body"
    class="text-gray-500 text-base lg:text-xl w-full py-8 text-center"
  >
    <slot name="no-data" />
  </div>
  <div
    v-else
    aria-label="table-body"
  >
    <div
      v-for="item in items"
      :key="item.id"
      aria-label="table-row"
      class="py-2 flex justify-between items-center space-x-4 border-b-2 border-gray-900/10 last:border-b-0 hover:bg-gray-50 px-1"
    >
      <slot :item="item" />
    </div>
  </div>
</template>

<script lang="ts" setup generic="T extends { id: string }">

defineProps<{
  loading: boolean
  items: T[] | null
}>()
</script>
